import { useMutation } from '@tanstack/react-query';
import { CreateProductVariations, DeleteProductVariation, UpdateProductVariations  } from '../../../Api/productVariations';

export const useMutateCreateProductVariations = () =>
  useMutation({
    mutationFn: (data) => CreateProductVariations(data),
  });

export const useMutateEditProductVariations = () =>
  useMutation({
    mutationFn: (data) => UpdateProductVariations(data),
  });

export const useMutateDeleteUserVariations = () =>
  useMutation({
    mutationFn: (data) => DeleteProductVariation(data),
  });